// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3Ol_6","rootCenter":"LoadMoreObserver_rootCenter__1Mmw_","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__22EpG"};